import { NgIf } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { CustomDynamicFormService } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/custom-dynamic-form.service';
import { CollisionPickerData } from '@gsm/entities';
import { DynamicFormModel } from '@ng-dynamic-forms/core';
import { DynamicMaterialFormComponent } from '@ng-dynamic-forms/ui-material';
import { setModelDisabled } from '../../helpers/disable-model.helper';
import { formElementsInvalid } from '../../helpers/form-elements-invalid.helper';
import { CollisionPickerModel } from '../collision-picker/collision-picker.model';
import { CustomDynamicFormControlComponent } from '../custom-dynamic-form-control.component';
import { GESCHAEDIGTES_FAHRZEUG_TEMPLATE_FACTORY } from './geschaedigtes-fahrzeug.config';
import { GeschaedigtesFahrzeugModel } from './geschaedigtes-fahrzeug.model';

@Component({
  selector:    'gsm-geschaedigtes-fahrzeug',
  templateUrl: './geschaedigtes-fahrzeug.component.html',
  styleUrls:   ['./geschaedigtes-fahrzeug.component.scss'],
  standalone:  true,
  imports:     [
    NgIf,
    MatFormField,
    MatLabel,
    MatSelect,
    FormsModule,
    MatOption,
    DynamicMaterialFormComponent
  ]
})
export class GeschaedigtesFahrzeugComponent extends CustomDynamicFormControlComponent<GeschaedigtesFahrzeugModel> implements OnInit {

  private formService = inject(CustomDynamicFormService);

  @ViewChild('form', {static: true}) formComponent: DynamicMaterialFormComponent;

  formModel: DynamicFormModel;
  formGroup: UntypedFormGroup;

  isSieheBeilage = false;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected onModelChange() {
    const json = GESCHAEDIGTES_FAHRZEUG_TEMPLATE_FACTORY(this.model.kfzTypesList || null, this.model.descriptionText);

    if (!this.model.value) {
      this.model.value = {};
    }

    if (this.model.disabled) {
      setModelDisabled(json, true);
    }

    this.formModel = this.formService.fromJSON(json);
    this.formGroup = this.formService.createFormGroup(this.formModel);
    this.isSieheBeilage = this.model.additional && this.model.additional.paperProcessOverride && !Object.keys(this.model.value).length;

    this._updateFormFromValue();
    this._emitChange();
  }

  protected onDisabledChange(): void {
    setModelDisabled(this.formModel, this.model.disabled);
    super.onDisabledChange();
  }

  private _updateFormFromValue() {
    if (this.model.value) {
      this.formGroup.reset();
      const {
        collisionPickerData = {} as CollisionPickerData,
        getScreenshotFile
      } = this.model.value;
      const {
        selectedFields: selection = [],
        kfzTyp = null
      } = collisionPickerData;

      const formGroupValue = {
        kfzTyp,
        selectedFields: {
          selection,
          getScreenshotFile
        }
      };
      this.formGroup.patchValue(formGroupValue);
      this._updateKfzTyp();
    }
  }

  onFormChange() {
    this._updateValueFromForm();
    this._updateKfzTyp();
    this._emitChange();
  }

  onSieheBeilageChange() {
    this._updateValueFromForm();
    this._emitChange();
  }

  private _emitChange() {
    this.group.get(this.model.id)
      .setErrors(this._getErrors());
    this.change.emit(this.model.value);
  }

  private _getErrors(): ValidationErrors {
    const invalid =
      !this.isSieheBeilage &&
      (!this.formGroup.get('kfzTyp').value ||
        formElementsInvalid(this.formGroup, this.formModel) ||
        !this.model?.value?.collisionPickerData?.selectedFields?.length);
    return invalid ? {geschaedigtesFahrzeug: true} : null;
  }

  private _updateValueFromForm() {
    if (this.isSieheBeilage) {
      this.model.value = {};
    } else {
      const formGroupValue = this.formGroup.getRawValue();
      const {
        selection: selectedFields,
        getScreenshotFile
      } = formGroupValue.selectedFields || ({} as any);
      this.model.value = {
        collisionPickerData: {
          kfzTyp: formGroupValue.kfzTyp,
          selectedFields
        },
        getScreenshotFile
      };
    }
  }

  private _updateKfzTyp() {
    const kfzPositionSelectionModel = this.formService.findModelById('selectedFields', this.formModel);
    (kfzPositionSelectionModel as CollisionPickerModel).kfzTyp =
      (this.model.value.collisionPickerData && this.model.value.collisionPickerData.kfzTyp) || null;
    this.formService.detectChanges(this.formComponent);
  }
}
